export const deleteAllDocumentsModalId = 'deleteAllDocumentsModal';
export const exportTraceLogsModalId = 'exportTraceLogsModal';
